import { Stack, useTheme } from "@mui/material";
import { ReactNode } from "react";
import sidebarBackground from "src/assets/images/sidebar-background.svg";
import { CONSTANTS } from "src/utils/constants";

type Props = {
  sidebar: ReactNode;
  baseSetup?: ReactNode;
  attributePanel: ReactNode;
  // Its pane is rendered even when absent, so both editors keep the same proportions
  partsList?: ReactNode;
  footer: ReactNode;
};

// Shared frame for configure-product and the bulk editor — only the slots differ.
export const ConfiguratorEditorLayout = (props: Props) => {
  const { sidebar, baseSetup, attributePanel, partsList, footer } = props;

  const theme = useTheme();

  return (
    <Stack direction="row" flex={1} overflow="hidden">
      <Stack
        width={CONSTANTS.CONFIGURE_PRODUCT_DRAWER_WIDTH}
        padding={4}
        overflow="auto"
        alignSelf="stretch"
        sx={{ backgroundImage: `url(${sidebarBackground})`, backgroundRepeat: "no-repeat", backgroundSize: "cover", backgroundPosition: "bottom" }}
      >
        {sidebar}
      </Stack>

      <Stack flex={1} overflow="hidden">
        <Stack direction="row" flex={1} overflow="hidden">
          <Stack>
            {baseSetup}
            <Stack bgcolor={theme.palette.customColors.white} margin={4} marginTop={3} marginBottom={4} width={300} overflow="hidden">
              {attributePanel}
            </Stack>
          </Stack>

          <Stack overflow="auto" borderRadius={1} border={`1px solid ${theme.palette.customColors.grey}`} bgcolor={theme.palette.customColors.lightGrey2} flex={1}>
            {partsList}
          </Stack>
        </Stack>
        <Stack px={4} py={2} direction="row" alignItems="center" justifyContent="space-between" bgcolor={theme.palette.customColors.white} borderTop={`1px solid ${theme.palette.customColors.grey}`}>
          {footer}
        </Stack>
      </Stack>
    </Stack>
  );
};
